<template>
    <b-loading :isFullPage="!block" v-model="isLoading">
        <svg
            version="1.1"
            id="L7"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 100 100"
            enable-background="new 0 0 100 100"
            xml:space="preserve"
        >
            <path
                stroke="var(--primary-color-click)"
                stroke-width="9"
                fill="none"
                stroke-linecap="round"
                d="M65.3,88.6c-21.3,8.4-45.4-2-53.8-23.3C3.1,44,13.5,19.9,34.8,11.5"
            >
                <animateTransform
                    attributeName="transform"
                    attributeType="XML"
                    type="rotate"
                    dur="2s"
                    from="0 50 50"
                    to="360 50 50"
                    repeatCount="indefinite"
                />
            </path>
            <path
                stroke="var(--primary-color-hover)"
                stroke-width="7"
                fill="none"
                stroke-linecap="round"
                d="M42.3,39.6c5.7-4.3,13.9-3.1,18.1,2.7,4.3,5.7,3.1,13.9-2.7,18.1"
            >
                <animateTransform
                    attributeName="transform"
                    attributeType="XML"
                    type="rotate"
                    dur="1s"
                    from="0 50 50"
                    to="-360 50 50"
                    repeatCount="indefinite"
                />
            </path>
            <path
                stroke="var(--primary-color)"
                stroke-width="8"
                fill="none"
                stroke-linecap="round"
                d="M25.6,60.9c-6-13.5,0-29.3,13.5-35.3,13.5-6,29.3,0,35.3,13.5"
            >
                <animateTransform
                    attributeName="transform"
                    attributeType="XML"
                    type="rotate"
                    dur="2s"
                    from="0 50 50"
                    to="360 50 50"
                    repeatCount="indefinite"
                />
            </path>
        </svg>
    </b-loading>
</template>
<script>
export default {
    props: {
        block: {
            type: Boolean,
            default: false,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
<style lang="scss" scoped>
svg {
    width: 150px;
    height: 150px;
    margin: 20px;
    display: inline-block;
}
</style>
